module.exports = __webpack_public_path__ + "images/emoji/sob.5c88039ebbe1d37cae7a.png";